import accounting from 'accounting'
import React, { useEffect, useState } from 'react'
import { calcTotalPrice } from '../calcTotalPrice'
import { useAuth } from '../hooks/useAuth'
import * as fp from '../lib/fpixel'
import * as ga from '../lib/ga'
import { getAuthUserProductAndPayment } from '../services/getAuthUserProductAndPayment'
import { AdSubPageData, StartPaymentFrontend } from '../Types/dto/startPayment'
import { formatDate } from '../utils/formatDate'
import env from '../configs/env'
import Checkout from './Checkout'
import Login from './Login'
import { EventTimeDTO, UserProductDTOFields } from '../Types/dto/user/product'
import { fetchWithBaseUrl } from '../../utils/api'
import useLocalStorageTX2 from '../hooks/useLocalStorageTX2'
import ReactGA from 'react-ga'
import Checkmark from './Checkmark'

export default function ShoppingCart({
	teamSlug,
	adSlug,
	userProductDTO,
	setIsLoginDialogOpenContainer,
	platform,
	startPaymentFrontend,
	setStartPaymentFrontend,
	isCheckoutVisible,
	setIsCheckoutVisible,
	adSubPageId,
	setAdSubPageId,
	planId,
	setPlanId,
	setTotalPrice,
	isLoginVisible,
	setIsLoginVisible,
	isCalendar,
	navigateToPaymentPressed,
}: {
	teamSlug: string
	adSlug: string
	userProductDTO: UserProductDTOFields
	updateBuyTicket2?: Function
	setIsLoginDialogOpenContainer?: Function
	platform: string
	startPaymentFrontend: StartPaymentFrontend
	setStartPaymentFrontend: React.Dispatch<
		React.SetStateAction<StartPaymentFrontend | null>
	>
	adSubPageId: string | null
	setAdSubPageId: React.Dispatch<React.SetStateAction<string | null>>
	planId: string | null
	setPlanId: React.Dispatch<React.SetStateAction<string | null>>
	isCheckoutVisible?: Boolean
	setIsCheckoutVisible?: React.Dispatch<React.SetStateAction<Boolean>>
	setTotalPrice?: React.Dispatch<React.SetStateAction<string | undefined>>
	isLoginVisible: Boolean
	setIsLoginVisible: React.Dispatch<React.SetStateAction<Boolean>>
	isCalendar?: Boolean
	navigateToPaymentPressed?: Function
}) {
	const [isTOSAccepted, setIsTOSAccepted] = useState<boolean>(false)
	const [missingFormField, setMissingFormField] = useState<string | undefined>(
		undefined
	)
	const [invalidFormField, setInvalidFormField] = useState<string | undefined>(
		undefined
	)
	const [isRedeemPassInProgress, setIsRedeemPassInProgress] =
		useState<Boolean>(false)
	const auth = useAuth()
	const [authUserProductAndPayment, setAuthUserProductAndPayment] = useState<
		{ [key: string]: any } | undefined
	>(undefined)
	//const [isLoginVisible, setIsLoginVisible] = useState<Boolean>(false)
	const [selectedTeamId, setSelectedTeamId] = useLocalStorageTX2<string>(
		'teamIdDashboard',
		''
	)
	const [isFetchUserPaymentDTOCompleted, setIsFetchUserPaymentDTOCompleted] =
		useState<boolean>(false)
	const [isClient, setIsClient] = useState(false)
	const [totalPriceInt, setTotalPriceInt] = useState<number | undefined>(
		undefined
	)
	const [totalPriceFormatted, setTotalPriceFormatted] = useState<
		string | undefined
	>(undefined)

	useEffect(() => {
		setIsClient(true)
	}, [])

	const formId = userProductDTO?.formId
	const pathname = window.location.pathname
	const pathSegments = pathname.split('/').filter((segment) => segment)
	const penultimateElement =
		pathSegments.length >= 2 ? pathSegments[pathSegments.length - 2] : ''

	useEffect(() => {
		if (auth.userDTO?.token && userProductDTO) {
			getAuthUserProductAndPayment(
				userProductDTO?.teamId,
				userProductDTO?.adId,
				setAuthUserProductAndPayment,
				auth.userDTO?.token
			).then(() => {
				setIsFetchUserPaymentDTOCompleted(true)
			})
		} else {
			if (auth.isUpdateUserDTOCompleted) {
				setIsFetchUserPaymentDTOCompleted(true)
			}
		}
		const myEvent = new CustomEvent('isRequiredToReload', {})
		window.dispatchEvent(myEvent)
	}, [auth.isUpdateUserDTOCompleted, userProductDTO])

	const startPaymentFrontendEventTimes = adSubPageId
		? Object.keys(
				startPaymentFrontend?.adSubPagesData?.[adSubPageId]?.eventTimes ?? {}
		  )
		: []
	const startPaymentFrontendFirstEventTimeId =
		startPaymentFrontendEventTimes.length > 0
			? startPaymentFrontendEventTimes[0]
			: undefined
	const eventTimeEntries = Object.entries(userProductDTO?.eventTimes ?? {})
	const firstEventTimeId =
		eventTimeEntries.length > 0 ? eventTimeEntries[0][0] : undefined
	const firstEventTime =
		eventTimeEntries.length > 0 ? eventTimeEntries[0][1] : undefined
	const eventTimeIds = Object.keys(eventTimeEntries ?? {})
	const adSubPagesEntries = Object.entries(
		startPaymentFrontend.adSubPagesData ?? {}
	)
	/*const firstAdSubPageId =
		adSubPagesEntries.length > 0 ? adSubPagesEntries[0][0] : undefined
	const defaultSubPageId =
		oneProduct?.defaultPlanId ??
		Object.keys(oneProduct?.adSubPages ?? {})[0]*/

	useEffect(() => {
		console.log('userProductDTO before if:', userProductDTO)
		if (userProductDTO) {
			console.log('userProductDTO after if:', userProductDTO)
			const eventTimeEntries = Object.entries(
				userProductDTO?.eventTimes ?? {}
			).sort(
				(a, b) =>
					new Date(a[1].startTime).getTime() -
					new Date(b[1].startTime).getTime()
			)
			const adSubPageIds = Object.keys(userProductDTO?.adSubPages ?? {})
			let _adSubPageId: string | null = adSubPageId
			if (
				(!adSubPageId || !adSubPageIds.includes(adSubPageId)) &&
				adSubPageIds.length > 0
			) {
				_adSubPageId = userProductDTO?.defaultPlanId ?? adSubPageIds[0]
			} else if (
				(!adSubPageId || !adSubPageIds.includes(adSubPageId)) &&
				adSubPageIds.length == 0
			) {
				// This can not happen
				return
			}
			if (!_adSubPageId) {
				return
			}
			const plans = userProductDTO?.adSubPages?.[_adSubPageId].plans
			const planIds = Object.keys(plans ?? {})
			let _planId: string | null = planId
			_planId = planIds[0] // move down defaultPlanId
			if (!_planId) {
				return
			}
			setAdSubPageId(_adSubPageId)
			setPlanId(_planId)
			const passTypeIds = Object.keys(userProductDTO?.passTypes ?? {})
			let startPaymentFrontendProduct =
				startPaymentFrontend?.adSubPagesData?.[_adSubPageId]

			if (!startPaymentFrontendProduct) {
				startPaymentFrontendProduct = {
					planId: _planId,
					quantity: 1,
				}
				if (
					eventTimeEntries.length > 0 &&
					userProductDTO?.timeSelectionType == 'oneOrManyTime'
				) {
					startPaymentFrontendProduct.eventTimes = {
						[eventTimeEntries[0][0]]: eventTimeEntries[0][1],
					}
				} else if (passTypeIds.length > 0) {
					startPaymentFrontend.passTypeId = passTypeIds[0]
				}
				let _startPaymentFrontend = { ...startPaymentFrontend }
				if (userProductDTO?.formFields) {
					let formFields: { [formFieldId: string]: string } = {}
					for (const [key, value] of Object.entries(
						userProductDTO?.formFields ?? {}
					)) {
						if (value.defaultFormFieldOptionId) {
							formFields[key] = value.defaultFormFieldOptionId
						}
					}
					_startPaymentFrontend.formFieldData = formFields
				}
				if (adSubPageIds.length == 1 || !_startPaymentFrontend.adSubPagesData) {
					_startPaymentFrontend.adSubPagesData = {}
				}
				_startPaymentFrontend.adSubPagesData[_adSubPageId] =
					startPaymentFrontendProduct
				setStartPaymentFrontend(_startPaymentFrontend)
			} else {
				// Lejárt időpontot felül írni, különben nem lehet jegyet venni
				// Ha bérlet volt kiválasztva, és újratölti, akkor se legyen időpont megadva
				if (
					eventTimeIds.length > 0 &&
					userProductDTO?.timeSelectionType == 'oneOrManyTime' &&
					((!startPaymentFrontend.passTypeId &&
						!startPaymentFrontendFirstEventTimeId) ||
						!eventTimeIds.includes(startPaymentFrontendFirstEventTimeId ?? ''))
				) {
					startPaymentFrontendProduct.eventTimes = {
						[eventTimeEntries[0][0]]: eventTimeEntries[0][1],
					}
				} else if (passTypeIds.length > 0 && !startPaymentFrontend.passTypeId) {
					startPaymentFrontend.passTypeId = passTypeIds[0]
				}
				if (startPaymentFrontend.passTypeId?.includes('\\s')) {
					startPaymentFrontend.passTypeId = 'empty'
				}

				// Ha nincs még időpont pl. csak bérlet van, akkor töröljük a pricing optiont.
				if (
					eventTimeIds.length == 0 &&
					passTypeIds.length > 0 &&
					userProductDTO?.timeSelectionType == 'oneOrManyTime' &&
					adSubPageId
				) {
					delete startPaymentFrontend.adSubPagesData[adSubPageId]
				} /*else if (
					// Ha konvertáltunk simple price-ból, s korábban már megnyitotta az oldalt, akkor is válasszon ki egy megfelelő opciót.
					// Ha esetleg olyan opció van kiválasztva ami már nem elérhető, akkor is reset.
					!startPaymentFrontendProduct.pricingOptionId ||
					!Object.keys(oneProduct?.adSubPages ?? {}).includes(
						startPaymentFrontendProduct.pricingOptionId
					)
				) {
					startPaymentFrontendProduct.pricingOptionId =
						oneProduct?.defaultPlanId ?? pricingOptionIds[0]
				}*/

				// TODO Check this
				let _startPaymentFrontend = { ...startPaymentFrontend }
				if (adSubPageIds.length == 1 || !_startPaymentFrontend.adSubPagesData) {
					_startPaymentFrontend.adSubPagesData = {}
				}
				_startPaymentFrontend.adSubPagesData[_adSubPageId] =
					startPaymentFrontendProduct
				setStartPaymentFrontend(_startPaymentFrontend)
			}
			localStorage.setItem('buyTicketData', JSON.stringify(userProductDTO))
		}
	}, [userProductDTO, adSlug])

	useEffect(() => {
		validate()
	}, [startPaymentFrontend, userProductDTO])

	/*useEffect(() => {
		// NOTE: Why?
		const startTime = startPaymentReqs?.[productSlug]?.startTime
		const endTime = startPaymentReqs?.[productSlug]?.endTime
		if (startTime && endTime) {
			const timeDifference =
				(new Date(endTime).getTime() - new Date(startTime).getTime()) /
				(1000 * 60 * 60)
			let startPaymentReq = {
				...startPaymentReqs?.[productSlug],
			}
			startPaymentReq.quantity = timeDifference
			setStartPaymentReqs({
				...startPaymentReqs,
				[productSlug]: startPaymentReq,
			})
		}
	}, [
		startPaymentFrontend?.products[productSlug]?.startTime,
		startPaymentFrontend?.products[productSlug]?.endTime,
	])*/

	const validate = () => {
		if (!startPaymentFrontend?.passTypeId && !adSlug) {
			setInvalidFormField(userProductDTO?.adSubPageSelectTitle)
			return
		}
		var isAllFormFieldValid = true
		for (const [key, value] of Object.entries(
			userProductDTO?.formFields ?? {}
		)) {
			if (value.hidden == true) {
				continue
			} else if (
				value.mandatory &&
				formId &&
				!startPaymentFrontend?.formFieldData?.[key]
			) {
				setMissingFormField(value.name)
				isAllFormFieldValid = false
			} else if (
				value.regex &&
				formId &&
				startPaymentFrontend?.formFieldData?.[key]
			) {
				let regex = new RegExp(value.regex)
				if (!regex.test(startPaymentFrontend?.formFieldData?.[key] ?? '')) {
					setInvalidFormField(value.name)
					setMissingFormField(undefined)
					isAllFormFieldValid = false
				}
			}
		}
		if (isAllFormFieldValid) {
			setMissingFormField(undefined)
			setInvalidFormField(undefined)
		}
	}

	useEffect(() => {
		if (userProductDTO?.name && platform == 'next') {
			ga.pageview(window.location.pathname, userProductDTO?.name, env)
			fp.event(
				'ViewContent',
				{
					content_ids: [adSlug],
					content_category: 'program',
					content_name: userProductDTO?.name,
					content_type: 'product',
					contents: [{ id: adSlug, quantity: 1 }],
					currency: 'HUF',
					value: 1,
				},
				env
			)
		}
	}, [userProductDTO])

	useEffect(() => {
		if (startPaymentFrontend?.passTypeId) {
			setTotalPriceFormatted(undefined)
		} else if (userProductDTO) {
			const _totalPriceInt = calcTotalPrice(
				startPaymentFrontend,
				userProductDTO,
				authUserProductAndPayment
			)
			setTotalPrice?.(`${_totalPriceInt}`)
			if (_totalPriceInt != undefined) {
				const _totalPriceFormatted = accounting.formatNumber(_totalPriceInt, {
					precision: 0,
					thousand: ' ',
				})
				setTotalPriceFormatted(_totalPriceFormatted)
			}
			setTotalPriceInt(_totalPriceInt)
		}
	}, [
		startPaymentFrontend,
		userProductDTO,
		authUserProductAndPayment,
		adSubPageId,
	])
	if (isCheckoutVisible) {
		return (
			<Checkout
				platform={'wordpress'}
				completion={() => {
					setIsCheckoutVisible?.(false)
				}}
				totalPriceFormatted={totalPriceFormatted}
				isCalendar={isCalendar}
			/>
		)
	}
	if (isClient) {
		return (
			<>
				{env == 'prod' && (
					<script
						defer
						dangerouslySetInnerHTML={{
							__html: `
									// Create BP element on the window
									window["bp"] = window["bp"] || function () {
										(window["bp"].q = window["bp"].q || []).push(arguments);
									};
									window["bp"].l = 1 * new Date();
							
									// Insert a script tag on the top of the head to load bp.js
									scriptElement = document.createElement("script");
									firstScript = document.getElementsByTagName("script")[0];
									scriptElement.async = true;
									scriptElement.src = 'https://pixel.barion.com/bp.js';
									firstScript.parentNode.insertBefore(scriptElement, firstScript);
									window['barion_pixel_id'] = '${
										userProductDTO?.barionPixelId ?? 'BP-amXD4jSXA3-27'
									}';            
						
									// Send init event
									bp('init', 'addBarionPixelId', window['barion_pixel_id']);
									`,
						}}
					/>
				)}
				{!startPaymentFrontend?.passTypeId &&
					userProductDTO?.adSubPages &&
					userProductDTO?.adSubPageSelectTitle != 'Jegytípus' &&
					userProductDTO?.adSubPages &&
					Object.keys(userProductDTO?.adSubPages ?? {}).length > 1 && (
						<h2>
							{userProductDTO.adSubPageSelectTitleByLang?.[
								penultimateElement
							] ?? userProductDTO?.adSubPageSelectTitle}
						</h2>
					)}
				{!setIsLoginDialogOpenContainer &&
					totalPriceFormatted &&
					isCalendar && (
						<div
							style={{
								display: 'flex',
								justifyContent: 'flex-end',
							}}
						>
							<span
								style={{
									fontWeight: 'bold',
									lineHeight: '50px',
									marginLeft: '16px',
								}}
							>
								Összeg: {totalPriceFormatted} Ft
							</span>
						</div>
					)}
				{!startPaymentFrontend?.passTypeId &&
					userProductDTO?.adSubPages &&
					adSubPageId &&
					Object.entries(userProductDTO?.adSubPages[adSubPageId]?.plans ?? {})
						.length > 1 && (
						<div
							style={{
								margin: '17px 0',
							}}
						>
							{Object.entries(
								userProductDTO?.adSubPages[adSubPageId].plans ?? {}
							)
								.sort((a, b) => (a[1].ind ?? 0) - (b[1].ind ?? 0))
								.map(([_planId, value]) => (
									<div
										style={{
											display: 'flex',
											justifyContent: 'flex-start',
											alignItems: 'center',
											height: '40px',
											cursor: 'pointer',
										}}
										key={_planId}
										onClick={(event) => {
											setStartPaymentFrontend({
												...startPaymentFrontend,
												adSubPagesData: {
													...startPaymentFrontend?.adSubPagesData,
													[adSubPageId]: {
														...startPaymentFrontend?.adSubPagesData[
															adSubPageId
														],
														planId: _planId,
													},
												},
											})
											setPlanId(_planId)
										}}
									>
										<Checkmark
											color={_planId == planId ? '#44A178' : '#D9D9D9'}
											checked={_planId == planId}
											showCircle={false}
										/>
										<p style={{ margin: '0' }}>
											{value.nameByLang?.[penultimateElement] ?? value.name}
										</p>
									</div>
								))}
						</div>
					)}
				{isLoginVisible ? (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Login
							completion={(userDTO) => {
								if (userDTO) {
									const organizations = userDTO.teams
									if (
										organizations &&
										Object.keys(organizations).length > 0 &&
										!selectedTeamId
									) {
										const teamId = Object.keys(organizations)[0]
										setSelectedTeamId(teamId)
									}
								}
								setIsLoginVisible(false)
							}}
							platform={'wordpress'}
							createTeamIfNotExist={false}
							lang={penultimateElement}
						/>
					</div>
				) : adSubPageId && planId ? (
					<>
						<br />
						<div className={'row'}>
							{Object.entries(userProductDTO?.passTypes ?? {}).length > 0 &&
								!authUserProductAndPayment?.payment && (
									<div className="col-lg-6 form-box-item">
										<p>&nbsp;</p>
										<select
											id="passTypes"
											value={startPaymentFrontend?.passTypeId ?? 'empty'}
											onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
												if (
													!adSubPageId ||
													!planId ||
													!firstEventTimeId ||
													!firstEventTime
												) {
													return
												}
												let _startPaymentFrontend = { ...startPaymentFrontend }
												let startPaymentFrontendProduct =
													_startPaymentFrontend?.adSubPagesData[adSubPageId]
												if (e.target.value == 'empty') {
													delete _startPaymentFrontend.passTypeId
													_startPaymentFrontend.adSubPagesData[adSubPageId] = {
														planId,
														quantity: 1,
														eventTimes: { [firstEventTimeId]: firstEventTime },
													}
												} else {
													_startPaymentFrontend.passTypeId = e.target.value
													delete _startPaymentFrontend.adSubPagesData[
														adSubPageId
													]
												}
												setStartPaymentFrontend(_startPaymentFrontend)
											}}
											className={'input-select'}
										>
											{Object.keys(userProductDTO?.eventTimes ?? {}).length >
												0 &&
												Object.entries(userProductDTO?.passTypes ?? {}).length >
													0 && (
													<option key={'empty'} value={'empty'}>
														Jegy
													</option>
												)}
											{Object.entries(userProductDTO?.passTypes ?? {})
												.sort((a, b) =>
													a[1]?.capacity > b[1]?.capacity ? 1 : -1
												)
												.map(([key, value]) => (
													<option key={key} value={key}>
														{value.capacity} alkalmas bérlet - {value.price} Ft
														{value.additionalInfo
															? ` ${value.additionalInfo}`
															: ''}
													</option>
												))}
										</select>
									</div>
								)}
							{!startPaymentFrontend?.passTypeId &&
								Object.keys(userProductDTO?.eventTimes ?? {}).length > 1 &&
								startPaymentFrontendFirstEventTimeId &&
								userProductDTO?.timeSelectionType == 'oneOrManyTime' && (
									<div className="col-lg-6 form-box-item">
										<p>Dátum</p>
										<select
											onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
												const _eventTime =
													userProductDTO?.eventTimes?.[e.target.value ?? '']

												if (!_eventTime || !adSubPageId || !planId) {
													return
												}
												setStartPaymentFrontend({
													...startPaymentFrontend,
													adSubPagesData: {
														...startPaymentFrontend?.adSubPagesData,
														[adSubPageId]: {
															...startPaymentFrontend?.adSubPagesData[
																adSubPageId
															],
															eventTimes: { [e.target.value]: _eventTime },
														},
													},
												})
											}}
											value={startPaymentFrontendFirstEventTimeId}
											className={'input-select'}
										>
											{Object.entries(userProductDTO?.eventTimes ?? {})
												.sort((a, b) =>
													new Date(a[1]?.startTime).getTime() >
													new Date(b[1]?.startTime).getTime()
														? 1
														: -1
												)
												.map(([k, v]) => {
													return (
														<option key={k} value={k}>
															{formatDate(v?.startTime, v?.endTime)}{' '}
															{v?.additionalInfo ?? ''}
														</option>
													)
												})}
										</select>
									</div>
								)}

							{userProductDTO?.timeSelectionType == 'oneOrManyTime' &&
								!startPaymentFrontend?.passTypeId &&
								startPaymentFrontend?.adSubPagesData[adSubPageId]?.quantity &&
								userProductDTO?.allowedPurchaseOnlyOneTicket != true && (
									<div className="col-lg-6 form-box-item">
										<p>Jegyek száma</p>
										<select
											onChange={(
												event: React.ChangeEvent<HTMLSelectElement>
											) => {
												if (!adSubPageId) {
													return
												}
												setStartPaymentFrontend({
													...startPaymentFrontend,
													adSubPagesData: {
														...startPaymentFrontend?.adSubPagesData,
														[adSubPageId]: {
															...startPaymentFrontend?.adSubPagesData[
																adSubPageId
															],
															quantity: parseInt(event.target.value),
														},
													},
												})
											}}
											value={
												startPaymentFrontend?.adSubPagesData?.[adSubPageId]
													?.quantity
											}
											className={'input-select'}
										>
											{[1, 2, 3].map((i) => (
												<option key={i}>{i}</option>
											))}
										</select>
									</div>
								)}
							{Object.entries(
								userProductDTO?.adSubPages?.[adSubPageId]?.plans[planId]
									?.paymentRecipients ?? {}
							)
								.sort((a, b) => a[0].localeCompare(b[0]))
								.map(([k2a, v2a], i2a) =>
									Object.entries(v2a.products ?? {})
										.sort((a, b) => a[1].name.localeCompare(b[1].name))
										.filter(
											(a) =>
												a[1].invoiceItemQuantityType == 'flexible' &&
												(platform == 'next' ||
													a[1].forceToShow ||
													!userProductDTO?.isQuantityEditorInWordpressEnabled)
										)
										.map(([key, value]) => (
											<div key={key} className="col-lg-6 form-box-item">
												<p>{value.dropdownTitle}</p>
												<select
													onChange={(
														event: React.ChangeEvent<HTMLSelectElement>
													) => {
														let i = parseInt(event.target.value)
														if (isNaN(i)) {
															i = 1
														}
														setStartPaymentFrontend({
															...startPaymentFrontend,
															adSubPagesData: {
																...startPaymentFrontend?.adSubPagesData,
																[adSubPageId]: {
																	...startPaymentFrontend?.adSubPagesData[
																		adSubPageId
																	],
																	productData: { [key]: i },
																},
															},
														})
													}}
													value={
														startPaymentFrontend?.adSubPagesData[adSubPageId]
															?.productData?.[key] ??
														userProductDTO?.adSubPages?.[adSubPageId]?.plans?.[
															planId
														]?.paymentRecipients?.[k2a].products?.[key]
															?.defaultValue ??
														'0'
													}
													className={'input-select'}
												>
													{Array.from(
														{
															length:
																(userProductDTO?.adSubPages?.[adSubPageId]
																	?.plans?.[planId]?.paymentRecipients?.[k2a]
																	.products?.[key]?.max ?? 2) + 1,
														},
														(_, i) => (
															<option key={key + '_' + i} value={i}>
																{`${i} ${
																	userProductDTO?.adSubPages?.[adSubPageId]
																		?.plans?.[planId]?.paymentRecipients?.[k2a]
																		.products?.[key]?.unit ?? ''
																} ${
																	i ==
																		userProductDTO?.adSubPages?.[adSubPageId]
																			?.plans?.[planId]?.paymentRecipients?.[
																			k2a
																		].products?.[key]?.max &&
																	userProductDTO?.adSubPages?.[adSubPageId]
																		?.plans?.[planId]?.paymentRecipients?.[k2a]
																		.products?.[key]?.unit == 'fő'
																		? '≤ (csoport)'
																		: ''
																}`}
															</option>
														)
													)}
												</select>
											</div>
										))
								)}
							{!startPaymentFrontend?.passTypeId &&
								userProductDTO?.formFields &&
								Object.entries(userProductDTO?.formFields ?? {})
									.filter(
										([k, v]) =>
											(!v.planId || v.planId == planId) && v.hidden != true
									)
									.sort((a, b) => (a[1].ind ?? 0) - (b[1].ind ?? 0))
									.map(([formFieldId, formFieldSchema]) => (
										<div
											key={formFieldId}
											className="col-lg-6 form-box-item"
											style={{ display: 'flex', flexDirection: 'column' }}
										>
											<p style={{ flexGrow: 1 }}>
												{formFieldSchema.nameByLang?.[penultimateElement] ??
													formFieldSchema.name ??
													''}
												{formFieldSchema.mandatory && (
													<span style={{ color: 'red' }}>{' *'}</span>
												)}
											</p>
											{formFieldSchema.details && (
												<p className="form-item-detail">
													{formFieldSchema.details ?? ''}
												</p>
											)}
											{formFieldSchema.type == 'selectItem' ? (
												<select
													onChange={(
														event: React.ChangeEvent<HTMLSelectElement>
													) => {
														setStartPaymentFrontend({
															...startPaymentFrontend,
															formFieldData: {
																...startPaymentFrontend?.formFieldData,
																[formFieldId]: event.target.value,
															},
														})
													}}
													value={
														startPaymentFrontend?.formFieldData?.[
															formFieldId
														] ??
														userProductDTO?.formFields?.[formFieldId]
															.defaultFormFieldOptionId ??
														''
													}
													className={'input-select'}
												>
													{formFieldSchema.options &&
														Object.entries(formFieldSchema.options).map(
															([key2, value2]) => (
																<option key={key2}>
																	{value2.nameByLang?.[penultimateElement] ??
																		value2.name ??
																		''}
																</option>
															)
														)}
													{userProductDTO?.formFields?.[formFieldId]
														.defaultFormFieldOptionId ?? (
														<option key={'empty'}> </option>
													)}
												</select>
											) : formFieldSchema.type == 'textField' ? (
												<input
													className={'input-text'}
													onChange={(
														event: React.ChangeEvent<HTMLInputElement>
													) => {
														setStartPaymentFrontend({
															...startPaymentFrontend,
															formFieldData: {
																...startPaymentFrontend?.formFieldData,
																[formFieldId]: event.target.value,
															},
														})
													}}
													value={
														startPaymentFrontend?.formFieldData?.[
															formFieldId
														] ?? ''
													}
												/>
											) : formFieldSchema.type == 'switchItem' ? (
												''
											) : (
												''
											)}
										</div>
									))}
						</div>
						<div style={{ marginTop: '30px' }}>
							<input
								type="checkbox"
								style={{ marginRight: '16px' }}
								onClick={(event: React.MouseEvent<HTMLInputElement>) => {
									setIsTOSAccepted(event.currentTarget.checked)
								}}
								defaultChecked={isTOSAccepted}
								data-cy="tos-accept"
							/>
							{penultimateElement == 'en' ? (
								<span>
									Yes, I have read and accept the Tikex.com{' '}
									<a
										href="https://tikex.com/aszf"
										style={{ textDecoration: 'underline' }}
									>
										terms of service
									</a>
									.<span style={{ color: 'red' }}>{' *'}</span>
								</span>
							) : (
								<span>
									Igen, a Tikex.com{' '}
									<a
										href="https://tikex.com/aszf"
										style={{ textDecoration: 'underline' }}
									>
										üzletszabályzatot
									</a>{' '}
									elolvastam és elfogadom.
									<span style={{ color: 'red' }}>{' *'}</span>
								</span>
							)}
						</div>
						<div>
							<input
								type="checkbox"
								style={{ marginRight: '16px' }}
								onClick={(event: React.MouseEvent<HTMLInputElement>) => {
									setStartPaymentFrontend({
										...startPaymentFrontend,
										hasSubscribedToNewsletter: event.currentTarget.checked,
									})
								}}
								defaultChecked={startPaymentFrontend?.hasSubscribedToNewsletter}
								data-cy="newsletter-subscribe"
							/>
							{penultimateElement == 'en' ? (
								<span>{`Yes, I would like to subscribe to the ${userProductDTO?.teamName} newsletter.`}</span>
							) : (
								<span>{`Igen, szeretnék feliratkozni ${userProductDTO?.teamName} hírlevélre.`}</span>
							)}
						</div>
						<div
							className="flex-responsive"
							style={{
								alignItems: 'flex-start',
								marginTop: '32px',
								gap: '16px',
							}}
						>
							{/*NOTE: Change it, in plugin also need check first user is on waitinglist */}
							{!auth?.userDTO && (
								<a
									className={
										'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
									}
									onClick={() => {
										if (platform == 'wordpress') {
											setIsLoginVisible(true)
										} else {
											window.location.replace(
												`/login?dst=${window.location.pathname.replace(
													'/',
													''
												)}`
											)
										}
									}}
								>
									{penultimateElement == 'en' ? (
										<>Registration</>
									) : (
										<>Regisztráció</>
									)}
								</a>
							)}
							{(!startPaymentFrontend?.passTypeId || auth?.userDTO) &&
								((!userProductDTO?.allowedDifferenceBetweenMenAndWomen ||
									auth?.userDTO) &&
								startPaymentFrontendFirstEventTimeId &&
								userProductDTO?.allowedDifferenceBetweenMenAndWomen &&
								((auth?.userDTO?.gender == 'man' &&
									(userProductDTO?.eventTimes?.[
										startPaymentFrontendFirstEventTimeId
									]?.numOfMen ?? 0) -
										(userProductDTO?.eventTimes?.[
											startPaymentFrontendFirstEventTimeId
										]?.numOfWomen ?? 0) >=
										(userProductDTO?.allowedDifferenceBetweenMenAndWomen ??
											0)) ||
									(auth?.userDTO?.gender == 'woman' &&
										(userProductDTO?.eventTimes?.[
											startPaymentFrontendFirstEventTimeId
										]?.numOfWomen ?? 0) -
											(userProductDTO?.eventTimes?.[
												startPaymentFrontendFirstEventTimeId
											]?.numOfMen ?? 0) >=
											(userProductDTO?.allowedDifferenceBetweenMenAndWomen ??
												0))) ? (
									<a
										className={
											'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
										}
										onClick={() => {
											if (
												userProductDTO?.waitingList?.find((v) => {
													return (
														v.userId == auth.userDTO?.userId &&
														v.eventTimeId ==
															startPaymentFrontendFirstEventTimeId
													)
												})
											) {
												alert('Már feliratkoztál erre az időpontra.')
												return
											}

											/*fetchWithBaseUrl(`subscribeWaitingList`, {
										method: 'POST',
										headers: {
											'Content-Type': 'application/json',
											Authorization: 'Bearer ' + auth.userDTO?.token,
										},
										body: JSON.stringify({
											productId: buyTicketData.productId,
											eventTimeId: startPaymentReqs?.[productSlug]?.eventTimeId,
											teamSlug,
										}),
									}).then((response) => {
										alert(
											'Hozzáadtunk az időponthoz tartozó várólistára, értesítünk, mihelyst lesz párod!'
										)
										buyTicketData?.waitingList?.push({
											userId: auth.userDTO?.userId ?? '',
											eventTimeId:
												startPaymentReqs?.[productSlug]?.eventTimeId ?? '',
											email: auth.userDTO?.email ?? '',
											createdAt: new Date().toISOString(),
										})
									})*/
										}}
									>
										Feliratkozok a várólistára
									</a>
								) : (
									<a
										className={
											'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
										}
										onClick={() => {
											if (!isTOSAccepted) {
												alert(`Olvasd el és fogadd el az üzletszabályzatot!`)
												return
											}
											if (!totalPriceInt && !startPaymentFrontend?.passTypeId) {
												alert('Kérlek jelölj meg egy vásárlási lehetőséget')
											} else if (
												!startPaymentFrontend?.passTypeId &&
												(missingFormField || invalidFormField)
											) {
												alert(
													!startPaymentFrontend?.passTypeId && missingFormField
														? `Töltsd ki az összes kötelező mezőt! pl. ${missingFormField}`
														: !startPaymentFrontend?.passTypeId &&
														  invalidFormField
														? `Töltsd ki helyesen a mezőket! pl. ${invalidFormField}`
														: `Olvasd el és fogadd el az üzletszabályzatot!`
												)
											} /*else if (
											oneProduct?.timeSelectionType == 'userSetTimeRange' &&
											!auth?.userDTO
										) {
											alert('Előbb jeletkezz be vagy regisztrálj')
										}*/ else {
												if (platform == 'wordpress') {
													setIsCheckoutVisible?.(true)
													const calendarElement =
														document.getElementById('calendar')
													if (calendarElement) {
														calendarElement.scrollIntoView({
															behavior: 'smooth',
														})
													}
												} else {
													ReactGA.event({
														category: 'Payment Process',
														action: 'Invoice Data',
													})
													window.location.href = `/checkout?dst=${window.location.pathname.replace(
														'/',
														''
													)}`
												}
											}
											if (isCalendar) {
												navigateToPaymentPressed?.()
											}
										}}
										data-cy="forward-to-payment"
									>
										{isCalendar ? (
											penultimateElement == 'en' ? (
												<>Proceed to basket</>
											) : (
												<>Tovább a kosárra</>
											)
										) : penultimateElement == 'en' ? (
											<>Proceed to payment</>
										) : (
											<>Tovább a fizetésre</>
										)}
									</a>
								))}
							{isFetchUserPaymentDTOCompleted ? (
								authUserProductAndPayment?.payment?._id &&
								startPaymentFrontendFirstEventTimeId &&
								userProductDTO?.eventTimes?.[
									startPaymentFrontendFirstEventTimeId
								] &&
								(!userProductDTO?.allowedDifferenceBetweenMenAndWomen ||
									!auth?.userDTO?.gender ||
									(auth?.userDTO?.gender == 'man' &&
										(userProductDTO?.eventTimes?.[
											startPaymentFrontendFirstEventTimeId
										]?.numOfMen ?? 0) -
											(userProductDTO?.eventTimes?.[
												startPaymentFrontendFirstEventTimeId
											]?.numOfWomen ?? 0) <
											(userProductDTO?.allowedDifferenceBetweenMenAndWomen ??
												0)) ||
									(auth?.userDTO?.gender == 'woman' &&
										(userProductDTO?.eventTimes?.[
											startPaymentFrontendFirstEventTimeId
										]?.numOfWomen ?? 0) -
											(userProductDTO?.eventTimes?.[
												startPaymentFrontendFirstEventTimeId
											]?.numOfMen ?? 0) <
											(userProductDTO?.allowedDifferenceBetweenMenAndWomen ??
												0))) &&
								(isTOSAccepted ? (
									<a
										className={
											'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
										}
										onClick={() => {
											if (!isTOSAccepted) {
												alert(`Olvasd el és fogadd el az üzletszabályzatot!`)
												return
											}
											if (isRedeemPassInProgress) {
												return
											} else {
												setIsRedeemPassInProgress(true)
											}
											let data = {
												paymentId:
													authUserProductAndPayment!.payment?._id.toString(),
												eventTimeId: startPaymentFrontendFirstEventTimeId,
												adSlug: adSlug,
												adSubPageId,
												planId,
											}
											let headers: {
												[key: string]: string | boolean
											} = {
												'Content-Type': 'application/json',
											}
											if (auth?.userDTO?.token) {
												headers[
													'Authorization'
												] = `Bearer ${auth?.userDTO?.token}`
											}
											fetchWithBaseUrl(`authUser/redeemPass`, {
												method: 'POST',
												headers: {
													'Content-Type': 'application/json',
													Authorization: 'Bearer ' + auth.userDTO?.token,
												},
												body: JSON.stringify(data),
											}).then(async (response) => {
												setIsRedeemPassInProgress(false)
												if (response.status != 200) {
													alert('Bérlet alkalmad beváltása nem sikerült')
													return
												}
												if (
													window.location.host == 'tikex.com' ||
													window.location.host == 'tikex-staging.com' ||
													window.location.host == 'tikex-dev.com' ||
													window.location.host == 'localhost:3000'
												) {
													window.location.replace(`/tickets`)
												} else {
													alert(
														'Jegyed a beváltott bérlet alkalomról elküldtük emailben.'
													)
													getAuthUserProductAndPayment(
														userProductDTO?.teamId,
														userProductDTO?.adId,
														setAuthUserProductAndPayment,
														auth.userDTO?.token
													)
												}
											})
										}}
									>
										Bérlet beváltás{' '}
										{authUserProductAndPayment.payment?.nextIndOfPass}/
										{authUserProductAndPayment.payment?.capacityOfPass}
									</a>
								) : (
									<a
										className={
											'btn btn-sm text-bold btn-circle shadow-1 full-width-sm'
										}
										style={{ marginTop: '35px', width: '250px' }}
										onClick={() => {
											if (!isTOSAccepted) {
												alert(`Olvasd el és fogadd el az üzletszabályzatot!`)
												return
											}
										}}
									>
										Bérlet beváltás{' '}
										{authUserProductAndPayment?.payment?.nextIndOfPass!}/
										{authUserProductAndPayment?.payment?.capacityOfPass!}
									</a>
								))
							) : (
								<img
									src={
										'https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca_w200.gif'
									}
									width={20}
									height={20}
									style={{
										width: '20px',
										height: '20px',
										marginTop: '45px',
									}}
								/>
							)}
							{!setIsLoginDialogOpenContainer &&
								totalPriceFormatted &&
								!isCalendar && (
									<span
										style={{
											fontWeight: 'bold',
											lineHeight: '50px',
											marginLeft: '16px',
										}}
									>
										Összeg: {totalPriceFormatted} Ft
									</span>
								)}
						</div>
					</>
				) : (
					<></>
				)}
			</>
		)
	} else {
		return <></>
	}
}
